import * as React from "react";
import { Sticky } from "@grandvisionhq/common";
import { calculateHeaderHeight } from "@grandvisionhq/utils";
const StickyAside = ({
  children,
  bottomBoundary,
  isEnabled
}) => {
  const [topOffset, setTopOffset] = React.useState(0);
  React.useEffect(() => {
    setTopOffset(calculateHeaderHeight());
  }, []);
  return /* @__PURE__ */ React.createElement(Sticky, { top: topOffset, bottomBoundary, enabled: isEnabled }, children);
};
export {
  StickyAside
};
//# sourceMappingURL=StickyAside.js.map
